export const transformDropOffPrintIcon = dropOffPrintIcon => ({
  url: dropOffPrintIcon.url,
  text: dropOffPrintIcon.text
});